import React, { useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
} from "reactstrap";
import logo from "assets/images/logo.svg";
import { Link } from "react-router-dom";
function Menu(args) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Navbar {...args} expand="lg">
      <NavbarBrand href="/">
        <img src={logo} alt={"logo"} />
      </NavbarBrand>
      {/* <NavbarToggler onClick={toggle} /> */}
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ms-auto" navbar>
          {/* <NavItem className="px-2">
            <Link className="text-white fw-500 fs-18 " to="/">
              Home
            </Link>
          </NavItem> */}
          {/* <NavItem className="px-2">
            <Link
              className="text-white fw-500 fs-18"
              href="https://github.com/reactstrap/reactstrap"
            >
              About
            </Link>
          </NavItem>
          <NavItem className="px-2">
            <Link
              className="text-white fw-500 fs-18"
              href="https://github.com/reactstrap/reactstrap"
            >
              Gym
            </Link>
          </NavItem>
          <NavItem className="px-2">
            <Link
              className="text-white fw-500 fs-18"
              href="https://github.com/reactstrap/reactstrap"
            >
              FAQ
            </Link>
          </NavItem>
          <NavItem className="px-2">
            <Link
              className="text-white fw-500 fs-18"
              href="https://github.com/reactstrap/reactstrap"
            >
              Contact Us
            </Link>
          </NavItem> */}
        </Nav>
      </Collapse>
    </Navbar>
  );
}

export default Menu;
